var map = {
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./footer/footer.module": [
		"./src/app/footer/footer.module.ts",
		"footer-footer-module"
	],
	"./header/header.module": [
		"./src/app/header/header.module.ts",
		"header-header-module"
	],
	"./login-with-otp/login-with-otp.module": [
		"./src/app/login-with-otp/login-with-otp.module.ts",
		"login-with-otp-login-with-otp-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"profile-profile-module"
	],
	"./registration/registration.module": [
		"./src/app/registration/registration.module.ts",
		"registration-registration-module"
	],
	"./resetpassword/resetpassword.module": [
		"./src/app/resetpassword/resetpassword.module.ts",
		"resetpassword-resetpassword-module"
	],
	"./splashpage/splashpage.module": [
		"./src/app/splashpage/splashpage.module.ts",
		"splashpage-splashpage-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;